<template>
  <div class="w-[400px] shrink-0 border-r border-gray-200 flex flex-col overflow-y-auto bg-gray-50">
    <div class="p-4 space-y-4">
      <!-- Project selector -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Project</label>
        <select
          v-model="selectedProjectId"
          @change="handleProjectChange"
          class="w-full text-sm border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-teal-500"
        >
          <option value="">Select a project...</option>
          <option v-for="p in store.projects.value" :key="p.id" :value="p.id">{{ p.name }}</option>
        </select>
      </div>

      <!-- Brief -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Brief</label>
        <p class="text-xs text-gray-500 mb-1">Describe the content you want to plan — themes, goals, angles...</p>
        <textarea
          v-model="store.brief.value"
          rows="6"
          class="w-full text-sm border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-teal-500 resize-none"
          placeholder="e.g., Content series about migrating from WordPress to modern headless CMS platforms. Focus on practical guides and addressing common fears..."
        ></textarea>
      </div>

      <!-- Count -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">How many ideas?</label>
        <input
          v-model.number="store.planCount.value"
          type="number"
          min="1"
          max="30"
          class="w-24 text-sm border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-teal-500"
        />
      </div>

      <!-- Knowledge items preview -->
      <div v-if="store.knowledgeItems.value.length">
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Knowledge ({{ store.knowledgeItems.value.length }} items)
        </label>
        <div class="space-y-1 max-h-32 overflow-y-auto">
          <div
            v-for="ki in store.knowledgeItems.value"
            :key="ki.id"
            class="text-xs text-gray-600 bg-white rounded border border-gray-200 px-2 py-1 truncate"
          >{{ ki.title }}</div>
        </div>
      </div>

      <!-- Generate button -->
      <button
        @click="store.generatePlan()"
        :disabled="!canGenerate"
        class="w-full py-2.5 rounded text-sm font-medium text-white transition-colors"
        :class="canGenerate ? 'bg-teal-600 hover:bg-teal-700' : 'bg-gray-300 cursor-not-allowed'"
      >
        <span v-if="store.generating.value">Generating...</span>
        <span v-else>Generate Plan</span>
      </button>

      <button
        v-if="store.generating.value"
        @click="store.stopGeneration()"
        class="w-full py-2 rounded text-sm font-medium text-gray-700 border border-gray-300 hover:bg-gray-100 transition-colors"
      >Stop</button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, inject } from 'vue'

const store = inject('planner')
const selectedProjectId = ref('')

const canGenerate = computed(() =>
  store.currentProject.value &&
  store.brief.value.trim() &&
  !store.generating.value
)

function handleProjectChange() {
  if (selectedProjectId.value) {
    store.selectProject(selectedProjectId.value)
  }
}
</script>
